import introspectionResult from './introspectionResult.json'

export * from './graphql'
const { possibleTypes } = introspectionResult
export { possibleTypes }
